import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState, AppThunk } from '..';
import { PatientData } from '../../generated-api';
import LimberAdminApi from '../../api/LimberAdminApi';
import { getFunctionPromisScore } from '../../utils/survey';

export interface PatientsError {
}

export interface PatientsState {
  loading: boolean;
  error: PatientsError | null;
  patients: Array<PatientData> | null;
}

const initialState: PatientsState = {
  loading: false,
  error: null,
  patients: null,
};

export const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    startLoading: (state) => { state.loading = true; },
    loadingFailed: (state, action: PayloadAction<PatientsError>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearError: (state) => { state.error = null; },

    loadPatientsSucceeded: (
      state, action: PayloadAction<Array<PatientData>>,
    ) => {
      state.loading = false;
      state.error = null;
      state.patients = action.payload;
    },
  },
});

const {
  startLoading, loadingFailed, loadPatientsSucceeded,
} = patientsSlice.actions;
export const { clearError } = patientsSlice.actions;

export const loadPatients = (
  getAccessToken: () => Promise<string>,
): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(startLoading());
    const accessToken = await getAccessToken();
    const api = new LimberAdminApi({ accessToken });
    const patients = await api.patientsGet();
    dispatch(loadPatientsSucceeded(patients));
  } catch (error) {
    console.error(error);
    dispatch(loadingFailed({
    }));
  }
};

export const selectPatients = (state: RootState) => state.patients;

export default patientsSlice.reducer;
